/* eslint-disable no-console */
'use strict';
var base = require('./base');

module.exports = {
    attributeSelect: base.attributeSelect,
    methods: base.methods,

    focusChooseBonusProductModal: base.focusChooseBonusProductModal,

    onClosingChooseBonusProductModal: base.onClosingChooseBonusProductModal,

    trapChooseBonusProductModalFocus: base.trapChooseBonusProductModalFocus,
    makeButtonAvailable: function () {
        $('body').on('pdp:enableAddProduct', function (e) {
            var $container = $(e.target);
            $container.find('.add-to-cart').removeAttr('disabled').html($('.add-to-cart').data('add-to-cart'));
        });
        $('body').on('pdp:disableAddProduct', function (e) {
            var $container = $(e.target);
            $container.find('.add-to-cart').attr('disabled', true).html($('.add-to-cart').data('out-of-stock'));
        });
    },
    colorAttribute: function () {
        $(document).on(
            'change',
            '[data-attr="color"] input[type=radio]',
            function (e) {
                e.preventDefault();
                if ($(this).attr('disabled')) {
                    return;
                }
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }

                var colorData = { color: $(this).attr('data-attr-value'), productID: $productContainer.attr('data-pid') };
                $('.js-selected-color').css('background-color', colorData.color);
                base.attributeSelect(
                    $(this).attr('data-url'),
                    $productContainer
                );
                $(document).trigger('GTM:colorSelected', colorData);
            }
        );
    },

    sizeAttribute: function () {
        $(document).on(
            'change',
            '[data-attr="size"] input[type=radio]',
            function (e) {
                e.preventDefault();
                if ($(this).attr('disabled')) {
                    return;
                }
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                var sizeData = { size: $(this).attr('data-attr-value'), productID: $productContainer.attr('data-pid'), displayValue: $(this).attr('data-attr-displayValue') };
                $('.js-selected-size').html(sizeData.displayValue);
                $('.error-message').hide();
                base.attributeSelect(
                    $(this).attr('data-url'),
                    $productContainer
                );
                $(document).trigger('GTM:sizeSelected', sizeData);
            }
        );
    },

    selectAttribute: base.selectAttribute,

    availability: base.availability,

    addToCart: base.addToCart,
    selectBonusProduct: base.selectBonusProduct,
    removeBonusProduct: base.removeBonusProduct,
    enableBonusProductSelection: base.enableBonusProductSelection,
    addBonusProductsToCart: base.addBonusProductsToCart,

    getPidValue: base.getPidValue,
    getQuantitySelected: base.getQuantitySelected,
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            // $('button.add-to-cart', response.$productContainer).attr('disabled',
            //     (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability')
                .toArray()
                .every(function (item) {
                    return (
                        $(item).data('available') &&
                        $(item).data('ready-to-order')
                    );
                });
            $('.pdp-cart-action').removeClass(
                !response.product.readyToOrder || !response.product.available
                    ? ''
                    : 'dummy'
            );
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    showSpinner: function () {
        $('body').on(
            'product:beforeAddToCart product:beforeAttributeSelect',
            function () {
                $.spinner().start();
            }
        );
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data(
                    'pid',
                    response.data.product.id
                );
            }
        });
    },
    shareButton: function () {
        $('#pdpShareButton').on('click', function (event) {
            event.preventDefault(); // Prevent the default anchor tag click behavior

            if (navigator !== undefined) {
                // check if navigator exists
                var shareTitle = $(this).data('sharetitle');
                var shareText = $(this).data('sharetext');
                var shareUrl = $(this).attr('href');

                if (navigator.share) {
                    // Check if the Web Share API is supported
                    navigator
                        .share({
                            title: shareTitle,
                            text: shareText,
                            url: shareUrl
                        })
                        .then(function () {
                            console.log('Shared successfully');
                        })
                        .catch(function (error) {
                            console.error('Error sharing:', error);
                        });
                } else {
                    console.log(
                        'Web Share API is not supported on this device.'
                    );

                    // Fallback: Copy the link to the clipboard using Clipboard API
                    try {
                        if ('clipboard' in navigator) {
                            navigator.clipboard
                                .writeText(shareUrl)
                                .then(function () {
                                    console.log('Link copied to clipboard.');
                                    $.toastr().showClipboard(
                                        'Link copied to clipboard.'
                                    );
                                    // Display a temporary notification
                                    // $("<div class='notification'>Link copied to clipboard!</div>")
                                    //     .appendTo($(this).parent())
                                    //     .fadeIn()
                                    //     .delay(1500)
                                    //     .fadeOut(function () {
                                    //         $(this).remove();
                                    //     });
                                })
                                .catch(function (error) {
                                    console.error(
                                        'Error copying link to clipboard:',
                                        error
                                    );
                                });
                        } else if (navigator.canShare) {
                            // Fallback: Use the canShare method
                            if (
                                navigator.canShare({
                                    title: shareTitle,
                                    text: shareText,
                                    url: shareUrl
                                })
                            ) {
                                window.location.href =
                                    'intent://share?url=' +
                                    encodeURIComponent(shareUrl) +
                                    '#Intent;package=com.sec.android.app.sbrowser;scheme=https;end;';
                            } else {
                                console.log('Share not supported.');
                            }
                        } else {
                            var dummyInput = document.createElement('input');
                            document.body.appendChild(dummyInput);
                            dummyInput.value = shareUrl;
                            dummyInput.select();
                            document.execCommand('copy');
                            document.body.removeChild(dummyInput);
                            $.toastr().showClipboard(
                                'Link copied to clipboard.'
                            );
                            // $("<div class='notification'>Link copied to clipboard!</div>")
                            //     .appendTo($(this).parent())
                            //     .fadeIn()
                            //     .delay(1500)
                            //     .fadeOut(function () {
                            //         $(this).remove();
                            //     });
                        }
                    } catch (error) {
                        console.error(
                            'Error copying link to clipboard:',
                            error
                        );
                    }
                }
            } else {
                console.log('navigator not found. too old browser.');
            }
        });
    },
    showLightBox: function () {
        $(document).on('click', '.js-size-guide', function () {
            $('.js-lightbox').removeClass('d-none');
            $('body').addClass('scroll-lock');
        });
    },
    hideLightBox: function () {
        $(document).on('click', '.js-close-size-guide', function () {
            $('.js-lightbox').addClass('d-none');
            $('body').removeClass('scroll-lock');
        });
    },
    hideProductFullView: function () {
        $(document).on('click', '.js-close-modal', function () {
            $('#productSliderModal').modal('hide');
        });
    },
    resetCheckbox: function () {
        $(document).ready(function () {
            $('[data-attr="color"] input[type=radio], [data-attr="size"] input[type=radio]').prop('checked', false);
            var selectedRadio = document.querySelector('[data-attr="color"] input[type=radio].selected, [data-attr="size"] input[type=radio].selected');
            // If a selected radio button exists, make sure it's checked
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
        });
    }
};
